<template>
  <div ref="menu" class="menu">
    <div class="header container">
      <div class="header__left">
        <IconButton
          class="header__icon"
          icon="cross"
          @click="handleCrossClick"
        />
      </div>

      <div class="header__middle"></div>

      <div class="header__right"></div>
    </div>
    <div class="menu__content">
      <Navigation />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import IconButton from "@/components/IconButton.vue";
import Navigation from "@/components/navigation/Navigation.vue";
import scrollLock from "@/helpers/scroll-lock";

export default {
  name: "BurgerMenu",
  components: {
    IconButton,
    Navigation,
  },
  computed: {
    orderNumber() {
      if (this.$route.name === "Order") {
        return this.$route.params?.orderNumber;
      }
      return false;
    },
  },
  mounted() {
    scrollLock.enable();
  },
  unmounted() {
    scrollLock.disable();
  },
  methods: {
    ...mapActions("app", ["toggleMobileMenu"]),
    ...mapActions("search", ["addSearchTerm"]),
    handleCrossClick() {
      this.toggleMobileMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: $color-white;
  height: 48px;

  @include respond-above(md) {
    position: relative;
    height: auto;
  }

  &__middle {
    flex: 1 0 auto;
    order: 1;
    text-align: center;
  }

  &__left,
  &__right {
    flex: 0 1 auto;

    @include respond-above(md) {
      flex: 1 1 0;
    }
  }

  &__left {
    order: 0;
  }

  &__right {
    order: 2;

    @include respond-above(md) {
      display: flex;
      justify-content: right;
    }
  }

  &__logo {
    vertical-align: top;
    padding: 15px 0;
  }

  &__icon {
    font-size: 24px;
    line-height: 1;
    padding: 10px;
  }
}

.menu {
  position: absolute;
  background: $color-white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;

  .header {
    flex: 0 0 auto;
  }

  &__content {
    flex: 0 1 100%;
    padding-top: 20px;
    overflow-x: scroll;
  }

  &__bottom {
    flex: 0 0 auto;
    background-color: $color-light;
    border-top: 1px solid rgba($color-dark, 0.2);
    display: flex;
    padding: 0 10px;
    justify-content: space-evenly;
  }

  &__button {
    padding: 17px 0;
    flex: 0 0 auto;
    background: none;
    outline: none;
    border: none;
    font-size: 10px;
    opacity: 0.4;
    text-decoration: none;

    &.router-link-active {
      opacity: 1;
    }
  }

  &__header {
    flex: 0 0 auto;
    background: $color-light;
    padding-top: 16px;
    padding-bottom: 16px;

    .heading {
      font-size: 16px;
      text-transform: uppercase;
      font-family: $heading-font-family;
    }
  }
}

.parent-route {
  margin-top: 14px;
  background-color: $color-white;
}

.back-button {
  font-family: $body-font-family;
  font-size: 10px;
  display: block;
  width: 100%;
  text-decoration: none;
  padding: 14px 0;

  .icon-arrow-left {
    margin-right: 10px;
  }
}
</style>
